export const environment = {
  production: false,
  apiUrl: "https://api.staging.worldleague.ca/api",
  authBaseUrl: "https://api.staging.worldleague.ca",
  tenantRuntime: { slug: "world-league", displayName: "World League" },
  stripePublishableKey: "pk_test_51P7kJeKikSlEATTTQrjCZZNZxCWMtEiOX6dvcB6cBTJFTPHHFHmYiJsNl80QkpWRAB5I1Pw6J1QrwkZeBLmfmsvD00Aeul198B"
};
